import Modal from "react-bootstrap/Modal";
import FormRoute from "./route/FormRoute";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import {useEffect} from "react";
import {ScheduleRouteModel} from "site-apps/distribution/schedules/ScheduleModels";


const ModalEditRoute = ({show, setShow, event = {router: null, id: null}, schedules, setSchedules}) => {


    useEffect(() => {
        subscribeEvent("route:modalform:change", handleCustomEvent);
        subscribeEvent("route:deleted", handleDeleteEvent);
        return () => {
            unsubscribeEvent("route:modalform:change", handleCustomEvent);
            unsubscribeEvent("route:deleted", handleDeleteEvent);
        }
    }, [schedules])

    const handleCustomEvent = (e) => {
        let routeId = `route-${e.detail.id}-${e.detail.type}`;
        let index = schedules.findIndex(r => r.id === routeId);
        let schedule = new ScheduleRouteModel(e.detail);
        let schedules_ = [...schedules];
        schedules_[index] = schedule;
        setSchedules(schedules_);
        unsubscribeEvent("route:modalform:change", handleCustomEvent);
    }
    // ruta borrada desde el formulario: se quita su evento del calendario
    const handleDeleteEvent = (e) => {
        let routeId = `route-${e.detail.id}-${e.detail.type}`;
        setSchedules(schedules.filter(r => r.id !== routeId));
        unsubscribeEvent("route:deleted", handleDeleteEvent);
    }
    const handleClose = () => {
        setShow(false);
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} size="xl" aria-modal="true">
                <Modal.Body className="bg-light">
                    <div className="container-fluid">
                        <div className="row">
                            <FormRoute format="modify" idModal={event.router} handleClose={handleClose}/>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>

    );
}
export default ModalEditRoute;